<template>
  <el-form ref="form" :model="form" :rules="rules" size="mini">
    <p class="text-red-600 text-sm pb-2">如实填入合格率，点击确认按钮自动计算变化情况。</p>
    <el-form-item label="数字化改造前的月均产品合格率" prop="before">
      <el-input-number :min="0" :max="100" v-model="form.before">
        <span slot="append">%</span>
      </el-input-number>
    </el-form-item>
    <el-form-item label="数字化改造后的月均产品合格率" prop="after">
      <el-input-number :min="0" :max="100" v-model="form.after">
        <span slot="append">%</span>
      </el-input-number>
    </el-form-item>
    <el-form-item>
      <el-button v-if="!isView" @click="handleSave" type="primary">确认</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  props: ['ans', 'isView', 'cb'],
  data () {
    return {
      form: {},
      rules: {
        before: { required: true, message: '请输入有效的合格率', trigger: 'blur' },
        after: { required: true, message: '请输入有效的合格率', trigger: 'blur' }
      }
    }
  },
  mounted () {
    this.form = { before: this.ans.before || 0, after: this.ans.after || 0, result: this.ans.result || 0 }
  },
  methods: {
    handleSave () {
      this.$refs.form.validate(valid => {
        if (valid) {
          Object.assign(this.form, { result: this.form.before > this.form.after ? -1 : (this.form.before === this.form.after ? 0 : 1) })
          this.cb(this.form)
        }
      })
    }
  }
}
</script>
